import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react"
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormGender: React.FC<Props> = props => {
  return (
    <IonItem>
      <IonLabel position="floating">Geschlecht</IonLabel>

      <IonSelect value={props.value} okText="Wählen" cancelText="Abbrechen" onIonChange={e => props.onChange((e.target as HTMLInputElement).value)}>
        <IonSelectOption value="f">Frau</IonSelectOption>
        <IonSelectOption value="m">Mann</IonSelectOption>
      </IonSelect>
    </IonItem>
  )
}

export default FormGender
